<template>
  <div class="h-full w-full relative">
    <div class="h-[calc(100%-58px)] w-full overflow-x-hidden overflow-y-auto pr-5px">
      <MarkerInfo
        ref="markerInfoRef"
        :Id="transferProps.Id"
        :player="player"
        :cloudRender="cloudRender"
      ></MarkerInfo>
      <RemarkList ref="remarkRef" v-if="transferProps.Id" :markerId="transferProps.Id"></RemarkList>
    </div>

    <div class="text-center w-full absolute bottom-0px">
      <el-button @click="openRemark" class="mr-20px" v-if="transferProps.Id">新增备注</el-button>
      <el-button @click="submit">保存标记</el-button>
    </div>
  </div>
</template>

<script>
import MarkerInfo from './components/info'
import RemarkList from './components/remarkList.vue'

export default {
  components: { MarkerInfo, RemarkList },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    player: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return { Id: '' }
  },
  methods: {
    openRemark() {
      this.$refs.remarkRef.openRemark()
    },
    async submit() {
      await this.$refs.markerInfoRef.validate()
      const [err, res, data] = await this.$refs.markerInfoRef.submit()
      if (!err && res.Code === 1) {
        this.Id = res.Data.Id || this.Id
        this.$message.success('保存成功！')

        const param = {
          ...data,
          Id: this.Id,
          pos: [data.XAxial, data.YAxial, data.ZAxial],
        }
        const event = new CustomEvent('useLabelFunction', {
          detail: {
            code: 'MarkerList',
            function: this.transferProps?.Id ? 'update' : 'addMarker',
            param,
          },
        })
        window.dispatchEvent(event)
        this.$emit('transferEvent', {
          type: 'transferData',
          code: 'MarkersManagement',
          data: { mode: 'refresh' },
        })
        if (this.transferProps?.Id) {
          setTimeout(() => {
            this.$emit('closeComponent', {
              code: 'MarkersManagementDetails',
              origin: 'business',
            })
          }, 500)
        }
      }
    },
  },
  mounted() {
    this.Id = this.transferProps?.Id
  },
  beforeDestroy() {
    this.$emit('transferEvent', {
      type: 'transferData',
      code: 'MarkersManagement',
      data: { mode: 'close' },
    })
  },
}
</script>
<style lang="scss" scoped>
::v-deep.el-button--default {
  color: #fff !important;
}
</style>
